import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import BCP from '../../../common/section_bcp/DM_BCP.js';
import { callProxy } from './VendorRenderer.jsx';
import { getLogger } from "@olympeio/core";

export function VendorDetailsRenderer(props) {
    const [vendors, setVendors] = React.useState([]);
    const { _id, description, currentColumnName, bcp, placeholder } = props;
    const logger = getLogger('VendorDetailsRenderer'); // Initialize logger
    // Retrieve vendors either from cache or from API
    React.useEffect(() => {
        let pickMainVendors = {};
        let pickSiteVendors = {};

        // Build body to fetch vendors from plants & materials if data not present
        const body = { offset: '0', limit: '100', plants: [bcp.get(BCP.plantIdProp)], materials: [bcp.get(BCP.materialIdProp)] };
        if (!_id) {
            // Run fetch
            callProxy(body).then((response) => {
                // API error
                if (response?.statusCode?.slice(0, 1) === 5 || response?.statusCode?.slice(0, 1) === 4) {
                    console.error(`API Error: ${response.statusCode} - ${response.message}`);
                    return;
                }
                if (currentColumnName === 'Main Vendor') {
                    pickMainVendors = (materials) => uniqueById(materials.flatMap((material) => material.mainVendor));
                    setVendors(pickMainVendors(response.materials));
                    return;
                } else if (currentColumnName === 'Vendor Site') {
                    pickSiteVendors = (materials) => uniqueById(materials.map((material) => {
                        return { id: material.vendorSiteNumber, description: material.vendorSiteDescription };
                    }));
                    setVendors(pickSiteVendors(response.materials));
                }
            }).catch((error) => logger.error(`Error while fetching Main vendor/ vendor site: ${error}`));
        }
    }, [currentColumnName]);

    return (vendors && vendors.length !== 0)
        ? (<List dense={true} sx={{ width: 1 }}>
            {vendors.map((vendor, index) => {
                return (
                    <ListItem key={index} style={{ paddingTop: '1px' }}>
                        <ListItemText primary={vendor.id} secondary={vendor.description} />
                    </ListItem>
                )
            })}
        </List>)
        :
        (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'space-around' }}>
            <Typography
                variant="body2"
                color="text.primary"
            >
                {_id || placeholder}
            </Typography>
            <Typography
                variant="body2"
                color="text.secondary"
            >
                {description || placeholder}
            </Typography>
        </div>);


}

/**
 * @param {!Array<*>} list
 * @return {!Array<*>}
 */
export function uniqueById(list) {
    return Array.from(new Map(list.map((item) => [item['id'], item])).values());
}